/* eslint-disable max-lines*/
/* eslint-disable array-element-newline */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-no-bind */
import React, {useState} from "react";
import InputField from "../../shared/components/InputField";
import LoadingSpinner from "../BuyItNow/components/LoadingSpinner";
import NonMemberCartAPI from "../../shared/modules/NonMemberCartAPI";
import NonMemberCartHeader from "./NonMemberCartHeader";
import PropTypes from "prop-types";
import StateField from "../../shared/components/StateField";

const AddressInfoForm = ({
  addressInfo,
  enable2024Legal,
  setAddressInfo,
  setAddresses,
  setDisplayErrors,
  setError,
  setIsEditingAddress,
  setSmsOptIn,
  setVerificationStep,
  smsOptIn
}) => {
  const {
    "email": existingEmail,
    "first_name": existingFirstName,
    "last_name": existingLastName,
    "street_address_1": streetAddressOne,
    "street_address_2": streetAddressTwo,
    "city": existingCity,
    "state": existingState,
    "zip": existingZip,
    "phone": existingPhone
  } = addressInfo;

  const [email, setEmail] = useState(existingEmail);
  const [firstName, setFirstName] = useState(existingFirstName);
  const [lastName, setLastName] = useState(existingLastName);
  const [streetAddress, setStreetAddress] = useState(streetAddressOne);
  const [unitNumber, setUnitNumber] = useState(streetAddressTwo);
  const [city, setCity] = useState(existingCity);
  const [state, setState] = useState(existingState);
  const [zipCode, setZipCode] = useState(existingZip);
  const [phone, setPhone] = useState(existingPhone);

  const [isLoading, setIsLoading] = useState(false);

  const handleErrorAfterVerification = (response) => {
    setAddresses({"enteredAddress": response.responseJSON.entered_address});
    setIsLoading(false);
    setVerificationStep(true);
  };

  const handleSuccessAfterVerification = (response) => {
    setAddresses({
      "enteredAddress": response.entered_address,
      "verifiedAddress": response.verified_address
    });
    setVerificationStep(true);
  };

  const submitAddressInfo = (event) => {
    event.preventDefault();
    setIsLoading(true);

    const address = {
      city,
      email,
      firstName,
      lastName,
      "optInToSms": smsOptIn,
      phone,
      state,
      streetAddress,
      unitNumber,
      zipCode
    };

    const validateAddress = () => {
      if (
        streetAddress &&
        city &&
        firstName &&
        lastName &&
        phone &&
        state &&
        zipCode &&
        email
      ) {
        return true;
      }
      return false;
    };

    if (validateAddress()) {
      setAddressInfo({
        city,
        email,
        "first_name": firstName,
        "last_name": lastName,
        "opt_in_to_sms": smsOptIn,
        phone,
        state,
        "street_address_1": streetAddress,
        "street_address_2": unitNumber,
        "zip": zipCode
      });
      NonMemberCartAPI.verifyAddress(address, handleSuccessAfterVerification, handleErrorAfterVerification);
    } else {
      setIsLoading(false);
      setError({"message": "Please fill out all required fields"});
      setDisplayErrors(true);
    }
  };

  const handleGoBack = () => {
    setIsEditingAddress(false);
  };

  const handleChangeInput = setStateFn => event => setStateFn(event.target.value);

  const handleCheckboxChange = (event) => {
    setSmsOptIn(event.target.checked);
  };

  const renderForm = () => (
    <form
      className="address-form"
      onSubmit={submitAddressInfo}
    >
      <InputField
        className="name-field"
        id="name-field-input"
        label="First Name"
        onChange={handleChangeInput(setFirstName)}
        required
        value={firstName}
      />
      <InputField
        className="name-field"
        id="name-field-input"
        label="Last Name"
        onChange={handleChangeInput(setLastName)}
        required
        value={lastName}
      />

      <InputField
        className="address-line-one-field"
        id="address-line-one-field-input"
        label="Address line 1"
        onChange={handleChangeInput(setStreetAddress)}
        required
        value={streetAddress}
      />
      <InputField
        className="address-line-two-field"
        id="address-line-two-field-input"
        label="Address line 2 (optional)"
        onChange={handleChangeInput(setUnitNumber)}
        value={unitNumber}
      />
      <InputField
        className="city-field"
        id="city-field-input"
        label="City"
        onChange={handleChangeInput(setCity)}
        required
        value={city}
      />
      <div className="state-field">
        <StateField
          changeHandler={handleChangeInput(setState)}
          label="State"
          labelAdditionalClassName="input-field-label"
          required
          selectClassName="input-field-input"
          selectId="state-field-input"
          state={state}
        />
      </div>
      <InputField
        className="zip-field"
        id="zip-field-input"
        label="Zip code"
        onChange={handleChangeInput(setZipCode)}
        required
        value={zipCode}
      />
      <div className="country-field">
        <label className="input-field-label">
          &nbsp;
        </label>
        <div className="country-field-value">
          United States
        </div>
      </div>
      <InputField
        className="email-field"
        id="email-input"
        label="Email"
        onChange={handleChangeInput(setEmail)}
        value={email}
      />
      <InputField
        className="phone-field"
        id="phone-field-input"
        label="Mobile number"
        onChange={handleChangeInput(setPhone)}
        type="tel"
        value={phone}
      />
      <div className="opt-in-field">
        <div className="opt-in-input">
          <InputField
            checked={smsOptIn}
            onChange={handleCheckboxChange}
            type="checkbox"
          />
          <div className="opt-in-text">
            Yes, I&apos;d like to receive updates about my account, shipments, exclusive offers, and more via SMS!
          </div>
        </div>
        <div>
          {
            smsOptIn && (
              <div className="opt-in-details">
                Checking this box is my signature to consent to receiving recurring automated transactional,
                promotional, and personalized marketing text messages (e.g. order updates, offers, and cart reminders)
                from Rocksbox at this cell phone number. Consent is not a condition of any purchase.
                Reply STOP to cancel. Msg frequency varies. Msg & data rates may apply.
                By enrolling you accept our&nbsp;
                <a href={enable2024Legal ? "/tos" : "/privacypolicy#tos"}>
                  Terms of Use
                </a>
                &nbsp;&&nbsp;
                <a href="https://www.rocksbox.com/privacypolicy">
                  Privacy Policy
                </a>
                .
              </div>
            )
          }
        </div>
      </div>
      <button
        className="btn btn-primary cart-save-button"
        disabled={isLoading}
        type="submit"
      >
        {isLoading ? <LoadingSpinner size={26} /> : "Save"}
      </button>
    </form>
  );

  return (
    <div className="address-info-edit">
      <NonMemberCartHeader
        classes="justify-start items-start gap-2.5 -mx-5 text-lg"
        handleBackButton={handleGoBack}
        showBackButton
        title="shipping & contact"
      />
      {renderForm()}
      <div className="mt16 rb-text-sm center">
        By clicking save, you agree to our&nbsp;
        <a
          className="underline"
          href="https://www.rocksbox.com/privacypolicy"
        >
          Privacy Policy&nbsp;
        </a>
        &&nbsp;
        <a
          className="underline"
          href={enable2024Legal ? "/tos" : "/privacypolicy#tos"}
        >
          Terms of Use
        </a>
        .
      </div>
    </div>
  );
};

AddressInfoForm.propTypes = {
  "addressInfo": PropTypes.object.isRequired,
  "enable2024Legal": PropTypes.bool.isRequired,
  "isShipping": PropTypes.bool.isRequired,
  "setAddressInfo": PropTypes.func.isRequired,
  "setAddresses": PropTypes.func.isRequired,
  "setDisplayErrors": PropTypes.func.isRequired,
  "setError": PropTypes.func.isRequired,
  "setIsEditingAddress": PropTypes.func.isRequired,
  "setSmsOptIn": PropTypes.func.isRequired,
  "setVerificationStep": PropTypes.func.isRequired,
  "shippingAddress": PropTypes.object,
  "smsOptIn": PropTypes.bool.isRequired
};

AddressInfoForm.defaultProps = {"shippingAddress": {}};

export default AddressInfoForm;
